export default __webpack_public_path__ + "static/media/bg-index2.72d32d1c.jpg";